export enum FulfillmentTabNames {
  Orders = 'Мої замовлення',
  Inbounds = 'Приймання',
  ProductBalances = 'Залишки товару',
}

export enum FulfillmentFormMode {
  Edit = 'edit',
  Create = 'create',
  Copy = 'copy',
}

export enum InboundStatus {
  New = 'Нове',
  ToDo = 'До виконання',
  InProgress = 'В роботі',
  Accepted = 'Прийнято',
  Placed = 'Розміщено',
  Cancelled = 'Скасовано',
}

export enum OrderStatus {
  New = 'Новий',
  Selected = 'Відібраний',
  Packed = 'Запакований',
  Shipped = 'Відвантажений',
  Canceled = 'Скасований',
  Blocked = 'Заблокований',
  ToPlan = 'До планування',
  PartiallyPlanned = 'Спланований частково',
  Planned = 'Спланований',
  ReadyToSelect = 'Готовий до відбору',
  ToSelect = 'До відбору',
  InSelection = 'У відборі',
  Controlled = 'Проконтрольований',
  ReadyToShip = 'Готовий до відвантаження',
}

export enum ProductBalanceStatus {
  Condition = 'Кондиція',
  Lost = 'Втрачено',
  Defect = 'Брак',
  ReceivingDefect = 'Брак приймання',
  WarehouseDefect = 'Брак складу',
  Broken = 'Бій',
  Repackaging = 'Переупаковка',
  Expired = 'Прострочення',
  Disposal = 'Утилізація',
}
